import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/miscellaneous`;

export const fullImportIcon: SvgIcon = `${iconsBasePath}/full-import.svg`;
export const incrementalImportIcon: SvgIcon = `${iconsBasePath}/incremental-import.svg`;
export const infoIcon: SvgIcon = `${iconsBasePath}/info.svg`;
export const logIcon: SvgIcon = `${iconsBasePath}/log.svg`;
export const deletedEntityIcon: SvgIcon = `${iconsBasePath}/deleted-entity.svg`;
export const errorIcon: SvgIcon = `${iconsBasePath}/error.svg`;
